import {action} from 'mobx';
import {DomainStore} from 'shared/store';
import {endpoints, types} from 'main/tools';

class InterviewScheduleDirectoryState {
  store = new DomainStore();
  history;

  receiveProps({history}) {
    this.history = history;
  }

  @action async createInterviewSchedule() {
    const {model} = await this.store.post(
      endpoints.INTERVIEW_SCHEDULES.ALL,
      types.INTERVIEW_SCHEDULE
    );

    this.history.push(`/interview-schedules/${model.id}/edit`);
  }

  @action async deleteInterviewSchedule(model) {
    await this.store.destroy(model);
  }
}

export default InterviewScheduleDirectoryState;
